import { Injectable } from '@angular/core';
import { BaseStoreRepository } from '../base-store.repository';
import { select } from '@ngneat/elf';
import { contactInitialState, ContactStateProps, contactStateStore } from './contact-state.store';
import { CompanyContactDto } from '@/types';

@Injectable({
  providedIn: 'root',
})
export class ContactRepository extends BaseStoreRepository<ContactStateProps> {
  constructor() {
    super(contactStateStore.pipe(select(state => state)), contactStateStore, contactInitialState);
  }

  getCompanyContactDto(): CompanyContactDto {
    return {
      contact: this.getNested('dto'),
      societeContactRequest: this.get('companyContactExtraDto'),
    };
  }
}
